import { CostObjectList } from './../models/cost-object-list.model';
import { ProjectData } from './../models/project-data.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProjectDataService {
  projectData: ProjectData;
  ecosysData: CostObjectList[];
}
